import { render, staticRenderFns } from "./FlexRow.vue?vue&type=template&id=70df903d&scoped=true&lang=pug&"
import script from "./FlexRow.vue?vue&type=script&lang=coffee&"
export * from "./FlexRow.vue?vue&type=script&lang=coffee&"
import style0 from "./FlexRow.vue?vue&type=style&index=0&id=70df903d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df903d",
  null
  
)

export default component.exports